import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://zfzrrhkavypcdcsyrucn.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpmenJyaGthdnlwY2Rjc3lydWNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE1MzYwODQsImV4cCI6MjA4NzExMjA4NH0.1sexbWolB7EKhyq14vfd7PcEdaKUg5tLPkEgtzEcIq8';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
